<form [formGroup]="createInvoiceModalForm" novalidate>
  <div class="create-invoice-modal">
    <div class="header">
      <h3 class="title" i18n>Create Invoice</h3>
      <a class="cancel-button" (click)="close(false)" tabindex="-1">
        <mat-icon>close</mat-icon>
      </a>
    </div>
    <div class="content step-1" *ngIf="!selectedOpportunityType">
      <div fxLayout="row wrap">
        <div class="option-tile lease-option" fxFlex="50">
          <a class="tile-link" (click)="selectOpportunityType(opportunityTypes.LEASE)" tabindex="-1">
            <div><img class="tile-image" src="assets/images/create-invoice-modal/lease.svg" alt="Lease"/></div>
            <div class="button-wrapper">
              <a mat-raised-button class="create-invoice-button" i18n>Lease</a>
            </div>
          </a>
        </div>
        <div class="option-tile sales-option" fxFlex="50">
          <a class="tile-link" (click)="selectOpportunityType(opportunityTypes.SALE)" tabindex="-1">
            <div><img class="tile-image" src="assets/images/create-invoice-modal/sale.svg" alt="Sale"/></div>
            <div class="button-wrapper">
              <a mat-raised-button class="create-invoice-button" i18n>Sale</a>
            </div>
          </a>
        </div>
        <div class="option-tile consulting-option" fxFlex="50">
          <a class="tile-link" (click)="selectOpportunityType(opportunityTypes.CONSULTING)" tabindex="-1">
            <div><img class="tile-image" src="assets/images/create-invoice-modal/consulting.svg" alt="Consulting"/></div>
            <div class="button-wrapper">
              <a mat-raised-button class="create-invoice-button" i18n>Consulting</a>
            </div>
          </a>
        </div>
        <div *ngIf="isValuationEnabled()" class="option-tile consulting-option" fxFlex="50">
          <a class="tile-link" (click)="selectOpportunityType(opportunityTypes.VALUATION)" tabindex="-1">
            <div><img class="tile-image" src="assets/images/create-invoice-modal/valuation.svg" alt="Valuation"/></div>
            <div class="button-wrapper">
              <a mat-raised-button class="create-invoice-button" i18n>Valuation</a>
            </div>
          </a>
        </div>
        <div class="option-tile dsf-option" fxFlex="50"
          *ngIf="!['KOR','TWN','SGP', 'IDN', 'HKG','CHN','THA','PHL','VNM'].includes(getUserCountry())">
          <a class="tile-link" (click)="selectOpportunityType(opportunityTypes.DSF)" tabindex="-1">
            <div><img class="tile-image" src="assets/images/create-invoice-modal/dsf.svg" alt="DSF" /></div>
            <div class="button-wrapper">
              <a mat-raised-button class="create-invoice-button" [class.disabled]="true" i18n>DSF</a>
            </div>
          </a>
        </div>
        <div class="option-tile expense-option" *ngIf="hideDisbursement() && ['KOR','THA','PHL','VNM'].includes(getUserCountry())" fxFlex="50">
          <a class="tile-link" (click)="createExpense()" tabindex="-1">
            <div><img class="tile-image" src="assets/images/create-invoice-modal/disbursement.svg" alt="Disbursement"/></div>
            <div class="button-wrapper">
              <a mat-raised-button class="create-invoice-button" i18n>Disbursement</a>
            </div>
          </a>
        </div>
        <div class="option-tile expense-option" *ngIf="hideDisbursement() && !['KOR','THA','PHL','VNM'].includes(getUserCountry())" fxFlex="50">
          <a class="tile-link" (click)="createExpense()" tabindex="-1">
            <div><img class="tile-image" src="assets/images/create-invoice-modal/disbursement.svg" alt="Disbursement"/></div>
            <div class="button-wrapper">
              <a mat-raised-button class="create-invoice-button" i18n>Disbursement</a>
            </div>
          </a>
        </div>
        <div class="option-tile resi-option" fxFlex="50" ivOptionTile
          animatedImage="assets/images/create-invoice-modal/resi.svg"
          *ngIf="['NZL'].includes(getUserCountry())">
          <a class="tile-link" (click)="selectOpportunityType(opportunityTypes.RESI)" tabindex="-1">
            <div><img class="tile-image" src="assets/images/create-invoice-modal/resi.svg" alt="RESI"/></div>
            <div class="button-wrapper">
              <a mat-raised-button class="create-invoice-button" i18n>Resi</a>
            </div>
          </a>
        </div>
      </div>
    </div>
    <div class="content step-2">
      <a class="back-button" (click)="back()"
        *ngIf="selectedOpportunityType">
        <div><mat-icon>keyboard_arrow_left</mat-icon><span i18n>Back</span></div>
      </a>
      <div class="step-2-wrapper" [ngClass]="{'step-2-wrapper': selectedOpportunityType !== opportunityTypes.RESI}">
        <div *ngIf="isPacificIsolationEnable() 
          && selectedOpportunityType === opportunityTypes.SALE" class="checkbox-business-line">
          <iv-checkbox-option
            id="e2e-hotel-business-btn"
            label="Hotel Business Line Sale" i18n-label
            (checkboxChanged)="saveHotelBusinessLine()"
            [model]="hotelBusinessLine"
            [key]="'hotel-business-line'"
            [labelCustomStyles]="{ 'font-size': '1.4rem' }"
            [disabled]="isHotelBusinessLineDisabled()">
          </iv-checkbox-option>
        </div>

        <div *ngIf="isIpMetroBusinessLineEnabled()" class="checkbox-business-line">
          <iv-checkbox-option
            id="e2e-ip-metro-business-line-btn"
            label="IP Metro Business Line" i18n-label
            (checkboxChanged)="saveIpMetroBusinessLine()"
            [model]="ipMetroBusinessLine"
            [key]="'ip-metro-business-line'"
            [labelCustomStyles]="{ 'font-size': '1.4rem' }"
            [disabled]="isIpMetroBusinessLineDisabled()">
          </iv-checkbox-option>
        </div>

        <div *ngIf="isResidentialBusinessLineEnabled()" class="checkbox-business-line">
          <iv-checkbox-option
            id="e2e-residental-business-line-btn"
            label="Residential Business Line" i18n-label
            (checkboxChanged)="saveResidentialBusinessLine()"
            [model]="residentialBusinessLine"
            [key]="'residential-business-line'"
            [labelCustomStyles]="{ 'font-size': '1.4rem' }"
            [disabled]="isResidentialBusinessLineDisabled()">
          </iv-checkbox-option>
        </div>

        <div class="formfields__container team-id-wrapper"
        *ngIf="selectedOpportunityType">
          <mat-form-field>
            <label for="team-id">
              <span id="team-id" i18n>Team</span>
              <span i18n class="optional-label"> (Which team does this transaction belong to?)</span>
            </label>
            <input
              id="team-id-type"
              matInput
              [matAutocomplete]="teamIdAutoComplete"
              formControlName="teamId"
              (input)="teamIdInput($event.target.value)" />
          </mat-form-field>
          <mat-autocomplete #teamIdAutoComplete>
            <mat-option 
              *ngFor="let team of teams"
              [value]="team.name"
              (onSelectionChange)="teamSelectionChange(team, $event)">
              <span id="team-id-{{team.id}}">{{ team.name }}</span>
            </mat-option>
          </mat-autocomplete>
        </div>

        <div class="opportunity-id-wrapper form-field-wrapper"
          *ngIf="selectedOpportunityType && selectedOpportunityType !== opportunityTypes.EXPENSE && selectedOpportunityType !== opportunityTypes.RESI">
          <label class="opportunity-label"><span i18n>Search Opportunity </span><span *ngIf="isClientIQIntegrationOn()" class="required">*</span></label>
          <div class="radio-container" fxLayout="row wrap">
            <mat-radio-group [(ngModel)]="searchOpportunityBy" [ngModelOptions]="{standalone: true}"
              (change)="onSearchCriteriaChange($event)" [disabled]="opportunitySpinner || defaultNaDisabled" color="primary">
              <mat-radio-button value="name" name="search-opportunity-by-name" id="search-opportunity-by-name">
                <span i18n>Name</span>
              </mat-radio-button>
              <mat-radio-button value="number" name="search-opportunity-by-number" id="search-opportunity-by-number">
                <span i18n>Number</span>
              </mat-radio-button>
              <mat-radio-button *ngIf="showNa" value="na" name="search-opportunity-by-na" id="search-opportunity-by-na">
                <span i18n>N/A</span>
              </mat-radio-button>
            </mat-radio-group>
          </div>
          <mat-form-field>
            <input 
              id="opportunity-id"
              matInput
              [matAutocomplete]="opportunityIdAutoComplete"
              formControlName="opportunityId"
              (input)="opportunityIdInput($event.target.value)" />
          </mat-form-field>
          <mat-autocomplete #opportunityIdAutoComplete>
            <mat-option *ngFor="let opportunity of opportunities" [value]="currentOppVal(opportunity)"
              (onSelectionChange)="opportunitySelectionChange(opportunity, $event)">
              <span class="client-name-{{opportunity.opp_name}}"
                matTooltip="{{ opportunity?.opp_name }} - {{ opportunity?.account_name }}">
                {{ currentOppVal(opportunity) }}
              </span>
            </mat-option>
          </mat-autocomplete>
          <ng-container *ngIf="opportunitySpinner">
            <span class="spinner-wrapper">
              <mat-spinner diameter="20" ></mat-spinner>
            </span>
          </ng-container>
        </div>

        <!-- INFO: FIN-6752 Add Installments Dropdown -->
        <ng-container *ngIf="isSalesForceAPI && searchOpportunityBy !== 'na'">
          <div class="formfields__container installment-id-wrapper">
            <mat-form-field>
              <label for="opportunity-installment-id" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                <span id="opportunity-installment-id" i18n>Opportunity Installment ID</span>
                <mat-icon color="primary" i18n-matTooltip
                  mdTooltipClass="multi-line-tooltip" matTooltipPosition="above"
                  matTooltip="Installment ID | Installment date | Installment Amount | Installment Status">
                  info
                </mat-icon>
              </label>
              <mat-select id="opportunity-installment-id-type"
                formControlName="opportunityInstallmentId" placeholder="Select One" i18n-placeholder floatPlaceholder="never">
                <mat-option *ngFor="let oiid of opportunityInstallments$ | async" [value]="oiid.value"
                  (onSelectionChange)="installmentsSelectionChange(oiid?.value, $event)">
                    <span id="installment-id-{{oiid.value}}">
                      {{ oiid.label }}
                    </span>
                </mat-option>
              </mat-select>
            </mat-form-field>
            <ng-container *ngIf="installmentsSpinner">
              <span class="spinner-wrapper">
                <mat-spinner diameter="20"></mat-spinner>
              </span>
            </ng-container>
          </div>
        </ng-container>

        <ng-container *ngIf="selectedOpportunityType === opportunityTypes.RESI">
          <iv-resi-create-invoice [formData]="['IND', 'SGP'].includes(getUserCountry()) ? resiFormModalDataINDSGP : resiFormModalData">
          </iv-resi-create-invoice>
        </ng-container>


        <div *ngIf="representDeal() && selectedOpportunityType && selectedOpportunityType !== opportunityTypes.EXPENSE && selectedOpportunityType !== opportunityTypes.VALUATION"
          class="question-wrapper">
          <span class="rep-label-question" i18n>Who did CBRE represent in this deal?</span>
          <span class="rep-label-instruction" i18n>Select One</span>
        </div>
        <div *ngIf="selectedOpportunityType === opportunityTypes.LEASE" class="representatives-wrapper clearfix">
          <button mat-raised-button type="button"
            [class.create-invoice-button]="selectedRepresentativeType !== representativeTypes.TENANT"
            [class.selected-create-invoice-button]="selectedRepresentativeType === representativeTypes.TENANT"
            class="left-button" (click)="selectRepresentativeType(representativeTypes.TENANT)" i18n>
            Tenant
          </button>
          <button mat-raised-button type="button"
            [class.create-invoice-button]="selectedRepresentativeType !== representativeTypes.LANDLORD"
            [class.selected-create-invoice-button]="selectedRepresentativeType === representativeTypes.LANDLORD"
            class="right-button" (click)="selectRepresentativeType(representativeTypes.LANDLORD)" i18n>
            Landlord
          </button>
        </div>
        <div *ngIf="selectedOpportunityType === opportunityTypes.SALE" class="representatives-wrapper clearfix">
          <button mat-raised-button
            type="button"
            [class.create-invoice-button]="selectedRepresentativeType !== representativeTypes.BUYER"
            [class.selected-create-invoice-button]="selectedRepresentativeType === representativeTypes.BUYER"
            class="left-button" (click)="selectRepresentativeType(representativeTypes.BUYER)" i18n>
            Buyer
          </button>
          <button mat-raised-button
            type="button"
            [class.create-invoice-button]="selectedRepresentativeType !== representativeTypes.SELLER"
            [class.selected-create-invoice-button]="selectedRepresentativeType === representativeTypes.SELLER"
            class="right-button" (click)="selectRepresentativeType(representativeTypes.SELLER)" i18n>
            Seller
          </button>
        </div>
        <div *ngIf="selectedOpportunityType === opportunityTypes.DSF" class="representatives-wrapper clearfix">
          <button mat-raised-button
            type="button"
            [class.create-invoice-button]="selectedRepresentativeType !== representativeTypes.BORROWER"
            [class.selected-create-invoice-button]="selectedRepresentativeType === representativeTypes.BORROWER"
            class="left-button" (click)="selectRepresentativeType(representativeTypes.BORROWER)" i18n>
            Borrower
          </button>
          <button mat-raised-button
            type="button"
            [class.create-invoice-button]="selectedRepresentativeType !== representativeTypes.LENDER"
            [class.selected-create-invoice-button]="selectedRepresentativeType === representativeTypes.LENDER"
            class="right-button" (click)="selectRepresentativeType(representativeTypes.LENDER)" i18n>
            Lender
          </button>
        </div>
        <div class="submit-wrapper" *ngIf="selectedOpportunityType">
          <button
            id="submit-button"
            mat-raised-button
            type="button"
            class="submit-button" i18n
            [disabled]="this.disableButton || !this.createInvoiceModalForm.valid"
            (click)="createInvoice()">
            Submit
          </button>
          <ng-container *ngIf="submitSpinner">
            <span class="spinner-wrapper">
              <mat-spinner diameter="20"></mat-spinner>
            </span>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</form>
